import { DEFAULT_STRAPI_STALE_TIME } from '@betterpool/strapi-client';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { LocationContext } from '~/components/providers/LocationProvider';
import { locationStorage } from '~/utils/locationStorage';

import getFeaturedContests from './getFeaturedContests';

const useFeaturedContests = () => {
  const { locationCountryNameSafe } = useContext(LocationContext);

  const effectiveLocation =
    locationCountryNameSafe ?? locationStorage.getBestAvailableLocationCountry();

  return useQuery({
    queryKey: ['cms@featuredContests', effectiveLocation],
    queryFn: () => getFeaturedContests(effectiveLocation),
    staleTime: DEFAULT_STRAPI_STALE_TIME,
  });
};

export default useFeaturedContests;
